module.exports = __webpack_public_path__ + "res/34-img_play.ab77de2f7d551a3ef1e0c6eeeac201c3.png";